import { Ref, ref } from 'vue';

interface IUsePullToRefresh {
  loadingPull: Ref<boolean>;
  loosingText: string;
  successText: string;
  pullingText: string;
  loadingText: string;
  onRefresh: () => void;
}

export default function (
  callback: () => Promise<any>,
  loosingText = 'Refreshing...',
  successText = 'Done',
  loadingText = 'Refreshing...',
  pullingText = 'Refreshing',
): IUsePullToRefresh {
  const loadingPull = ref(false);
  function onRefresh() {
    loadingPull.value = true;
    callback().finally(() => {
      loadingPull.value = false;
    });
  }

  return {
    loadingPull,
    loosingText,
    successText,
    pullingText,
    loadingText,
    onRefresh,
  };
}
